import React from 'react'

import { useSessionTimeout } from '../context/SessionTimeoutContext'
import { Modal } from '../modal/Modal'
import { SessionExpirationModal } from '../modal/SessionExpirationModal'

export const SessionTimeout: React.FC = () => {
  const sessionTimeoutContext = useSessionTimeout()

  if (!sessionTimeoutContext) {
    return null
  }

  const { warningModal, onLogout, onStayConnected, timer, redirectAfter } = sessionTimeoutContext

  if (!warningModal) {
    return null
  }

  return (
    <Modal
      closeModal={onLogout}
      render={() => (
        <SessionExpirationModal
          onLogout={onLogout}
          onStayConnected={onStayConnected}
          redirectAfter={redirectAfter}
          timer={timer}
        />
      )}
    />
  )
}
